export const SELECT_ECOSYSTEM_PAGE_NS = 'pages/SelectEcosystemPage';

export const i18n = {
  en: {
    title: 'Select Ecosystem',
  },
};
